export function isLanguagePackageType(text) {
  if (text) {
    if (typeof text !== 'string') {
      text += ''
    }
    return text.match(/^{{/) && text.match(/}}$/)
  } else {
    return false
  }
}

export function getLanguagePackageId(text) {
  return text.replace('{{', '').replace('}}', '')
}
